<template>
  <div id="contact">
    <div class="modal__overlay" v-if="modal"></div>
    <transition name="fade">
      <div class="modal modal__contact" v-if="modal">
        <span @click="closeModal" class="modal__close">&times;</span>
        <span class="modal__title">Contacter le webmaster</span>
        <form action="#" @submit.prevent="sendMessage">
          <label for="email">Votre adresse email</label><br>
          <input id="email" type="email" required v-model="email"><br>
          <label for="message">Votre message</label><br>
          <textarea id="message" required v-model="message"></textarea><br>
          <input type="hidden" :value="nonce">
          <p>Les informations recueillies à partir de ce formulaire permettent au Département des Yvelines d'améliorer les informations proposées sur le site «https://plan.yvelines.fr/».
             Elles sont transmises à la direction de la communication et le cas échéant aux services du département en charge du lieu concerné par vos remarques.
             <a href="https://plan.yvelines.fr/mentions-du-formulaire-de-remarque/">En savoir plus sur la gestion de vos données et vos droits</a></p>
          <button type="submit">Envoyer</button>
        </form>
        <span class="response" :class="{ 'error': error, 'success': !error }" v-if="sent">
          {{response}}
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
  /* global cgy_vars */
  /* global dataLayer */
  /* eslint no-undef: "error" */

  // import store from '../store/store'
  import json from '../store/jsonUrl'

  export default {
    name: 'contact',
    data () {
      return {
        modal: false,
        email: '',
        message: '',
        nonce: cgy_vars.form.nonce,
        placeId: '',
        sent: false,
        response: '',
        error: false
      }
    },
    methods: {
      contactOnClick: function (place) {
        this.modal = true
        if (place) {
          this.placeId = place.id
          this.message = `\n\n---------------\nSupprimez ou changez le texte ci-dessous si votre remarque concerne un autre lieu ou sujet. \nLieu concerné: ${place.name}`
        }
      },
      sendMessage: function () {
        let data = this.dataMessageInit()
        this.$http.post(json.url.form, data, {emulateJSON: true}).then((response) => {
          this.sent = true
          this.response = response.body.message
          dataLayer.push({event: 'contact_webmaster_form_sent'})
        }, (response) => {
          this.sent = true
          this.error = true
          console.log('error', response)
        })
      },
      dataMessageInit: function () {
        let nav = []
        let arr = ['userAgent', 'vendor', 'vendorSub', 'product', 'productSub', 'onLine', 'platform', 'language', 'cookieEnabled', 'doNotTrack', 'appCodeName', 'appName', 'appVersion']
        for (let i = 0; i < arr.length; i++) {
          nav.push(`${arr[i]}:${navigator[arr[i]]}`)
        }
        let data = {
          'mail': this.email,
          'message': this.message,
          'nonce': this.nonce,
          'navigator': nav.join('\n'),
          'location': this.placeId || ''
        }
        return data
      },
      closeModal: function () {
        this.sent = false
        this.modal = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Contact.vue?aba6c9d0